/**
 * Client-side mirror of the server's PricingFormulaService.evaluateFormula
 * (orderwerks-node/src/services/PricingFormulaService.ts). Used only for the
 * live kit-builder total preview; the authoritative price is still computed on
 * the server when the line is added/updated. Keep this in sync with the server.
 */

export interface IPricingVariables {
    qty: number;
    price: number;
    depth?: number;
    width?: number;
    height?: number;
}

export default class PricingFormulaService {
    /**
     * Evaluate a pricing formula template (e.g. "qty * depth * price / 1000") with the given variables.
     * Returns undefined if the expression is malformed or the result is not a finite number, so callers
     * can fall back to a simpler estimate instead of showing NaN.
     */
    static evaluateFormula(formula: string, variables: IPricingVariables): number | undefined {
        let expression = formula.toLowerCase();

        expression = expression.replace(/\bqty\b/g, String(variables.qty || 0));
        expression = expression.replace(/\bprice\b/g, String(variables.price || 0));
        expression = expression.replace(/\bdepth\b/g, String(variables.depth || 0));
        expression = expression.replace(/\bwidth\b/g, String(variables.width || 0));
        expression = expression.replace(/\bheight\b/g, String(variables.height || 0));

        // Only allow arithmetic characters — same guard as the server.
        if (!/^[\d\s+\-*/().]+$/.test(expression)) {
            return undefined;
        }

        let result: number;

        try {
             
            result = new Function("return " + expression)();
        } catch {
            return undefined;
        }

        if (typeof result !== "number" || isNaN(result) || !isFinite(result)) {
            return undefined;
        }

        return Number(result);
    }
}
